function Injectorator() {
    this.registry = {}; // things that can be instantiated
    this.instances = {}; // things that have been instantiated
}

Injectorator.prototype = {
    _isFunction(subject) {
        return typeof subject == 'function';
    },

    _makeErrorAndLog(msg) {
        const errorMessage = `[I] ${msg}`;
        console.error(errorMessage);
        return new Error(errorMessage);
    },

    _instantiateWithDependencies(name) {
        this._findDependencies(name).forEach(this._instantiate.bind(this));
    },

    _instantiate(name) {
        if (
            this.instances.hasOwnProperty(name) ||
            !this.registry.hasOwnProperty(name)
        ) {
            // OK to bail in this case, callling code will raise appropriate exception
            return false;
        }

        const entry = this.registry[name];
        let subject = entry.subject;

        if (this._isFunction(subject)) {
            const args = this._getArgumentList(entry.dependencies);
            subject = subject(...args);
        }

        this.instances[name] = subject;
        return true;
    },

    _getArgumentList(dependencies, extraInstances) {
        extraInstances = extraInstances || {};

        return dependencies.map(function(e) {
            if (this.instances.hasOwnProperty(e)) {
                return this.instances[e];
            } else if (extraInstances.hasOwnProperty(e)) {
                return extraInstances[e];
            } else {
                throw this._makeErrorAndLog(`Dependency not found: '${e}'`);
            }
        }, this);
    },

    // does a topological search over the dependencies
    _findDependencies(name) {
        const ordered = [];
        let stackGuard = 50;
        const finder = function(name) {
            if (stackGuard-- < 0) {
                const errorMessage = `Found cyclic dependency while trying to resolve '${name} <- ${this
                    .registry[name].dependencies}'`;
                throw this._makeErrorAndLog(errorMessage);
            }

            if (
                this.instances.hasOwnProperty(name) ||
                !this.registry.hasOwnProperty(name)
            ) {
                return;
            }

            this.registry[name].dependencies.forEach(e => {
                if (ordered.indexOf(e) === -1) {
                    finder(e);
                }
            });

            ordered.push(name);
        }.bind(this);

        finder(name);

        return ordered;
    },

    register(name, subject, deps) {
        deps = deps || [];
        this.registry[name] = {
            name,
            dependencies: deps,
            subject,
        };
    },

    registerInstance(name, subject) {
        this.registry[name] = {
            name,
            dependencies: [],
            subject,
        };
        this.instances[name] = subject;
    },

    get(name) {
        if (!this.registry.hasOwnProperty(name)) {
            throw this._makeErrorAndLog(`Injectable not found: '${name}'`);
        }

        if (!this.instances.hasOwnProperty(name)) {
            this._instantiateWithDependencies(name);
        }

        return this.instances[name];
    },

    call(callable, dependencies, localDependencies) {
        dependencies.forEach(this._instantiateWithDependencies, this);
        const args = this._getArgumentList(dependencies, localDependencies);
        callable(...args);
    },
};

export default Injectorator;



// WEBPACK FOOTER //
// ./lib/Injectorator.js